hrd.form.openFormDialog = function(html, inputData, options, formOptions) {
	var deferred = $.Deferred();
	var $content = $(html).appendTo('body');
	var dialogId = '#' + $content.uniqueId().attr('id');
	this.showFormDialog(dialogId, inputData, options, formOptions)
		.then(function(obj, options) {
			deferred.resolve(obj, options);
		}).progress(function(obj, options) {
			deferred.notify(obj, options);
		}).fail(function(options) {
			deferred.reject(options);
		}).always(function() {
			setTimeout(function() {
				$content.remove();
			}, 0);
		});
	return deferred.promise();
};

hrd.form.isFormDialogOpened = function(dialogId) {
	var $dialog = $(dialogId);
	return $dialog.hasClass("ui-dialog-content") ? $dialog.dialog('isOpen') : false;
};

hrd.form.closeFormDialog = function(dialogId) {
	if (this.isFormDialogOpened(dialogId)) {
		var $dialog = $(dialogId);
		$dialog.dialog('close');
	}
};

hrd.form.showFormDialog = function(dialogId, inputData, options, formOptions) {
	var deferred = $.Deferred();
	var $dialog = $(dialogId);
	if (!$dialog.exists()) {
		hrd.dashboard.msgBox({
			title: 'Warning',
			text: 'Dialog Id does not exists: "' + dialogId + '"',
			type: 'OK'
		});
	}

	var defaults = {
		dialogClass: undefined,
		modal: true,
		resizable: false,
		closable: false,
		maximizable: false,
		minimizable: false,
		resizeOnDlbclick: false,
		position: { my: "center", at: "center", of: window }, // from jquery ui
		show: undefined,
		hide: undefined,
		okLabel: xlate('common.dialog.ok.btn'),
		cancelLabel: xlate('common.dialog.cancel.btn'),
		width: 300,
		minHeight: undefined,
		keepOriginalWidth: false,
		doNotCloseOnOk: false,
		overflow: false,
		intermediateResult: false, // utile per lanciare deferred.notify e non risolvere prematuramente la promise
		errorMessagePosition: 'element', // Can be either "top" or "element" or "custom"
		ignoreValidationWhenHidden: false,
		ignoreValidationOnOk: false,
		height: 'auto',
		onOpen: undefined,
		extraButtons: [],
		showOkButton: true,
		showCancelButton: true,
		hideHeader: false,
		arrangeFieldSet: {},
		returnFreshObject: false,
		reference: undefined,// needed for faster implementations
		title: null, // it means: use the html defined one
		closeOnOverlay: false,
		// form events
		onSetDataForm: undefined,
		showEditableMarker: false,
		destroyOnClose: false,
		skipResetOnFail: false,
		backgroundPath: undefined,
		rejectMessage: undefined,
		onPreClose: () => $.when(),
	};
	options = options || {};
	formOptions = formOptions || {};

	if ($dialog.data('width')) {
		options.width = $dialog.data('width');
	}

	if ($dialog.data('height')) {
		options.height = $dialog.data('height');
	}

	if ($dialog.data('title') && !options.title) {
		options.title = $dialog.data('title');
	}

	if ($dialog.data('ok-label') && !options.okLabel) {
		options.okLabel = $dialog.data('ok-label');
	}

	if ($dialog.data('cancel-label') && !options.cancelLabel) {
		options.cancelLabel = $dialog.data('cancel-label');
	}

	if ($dialog.data('dialog-class') && !options.dialogClass) {
		options.dialogClass = $dialog.data('dialog-class');
	}

	var settings = $.extend({}, defaults, options);

	const backgroundPath = settings.backgroundPath;

	if (backgroundPath) {
		cssVar.set('background-image', `url(${backgroundPath})`, $dialog.get(0));
	}

	/*
	 * Detect if the dialog has a specific reference instance
	 */
	var dialogImpl = $dialog.data('dialogImpl');
	if ($dialog.data('popup') && dialogImpl == undefined) {
		var dialogInfo = $.evaluate($dialog.data('popup'));
		$dialog.data('popupInfo', dialogInfo);
		if (dialogInfo.impl) {
			var dOpt = {
				impl: dialogInfo.impl,
				prefix: dialogInfo.prefix,
			}
			if (dialogInfo.options) {
				dOpt = $.extend(dOpt, dialogInfo.options);
			}
			dialogImpl = $.evaluate('new impl(panel, opts)', this, [$.evaluate(dialogInfo.impl), $dialog, dOpt], ['impl', 'panel', 'opts']);
			dialogImpl.uuid = parseInt(Math.random() * 1000);
		} else {
			if (settings.reference instanceof hrd.AbstractFormPopup) {
				dialogImpl = settings.reference;
				dialogImpl.uuid = parseInt(Math.random() * 1000);
				if (dialogInfo.prefix) {
					dialogImpl.settings.prefix = dialogInfo.prefix; // forcing
				}
				if (dialogInfo.options) {
					dialogImpl.settings = $.extend(dialogImpl.settings, dialogInfo.options);
				}
			}
		}
		$dialog.data('dialogImpl', dialogImpl); // store for next use
	}
	if ($dialog.data('useAsDialogImplementation')) {
		dialogImpl = settings.reference;
	}
	if (dialogImpl != undefined) {
		if (settings.reference != undefined && settings.reference != dialogImpl) {
			console.log('reference attribute is ignored and changed with something else');
		}
		settings.reference = dialogImpl;
		if (typeof settings.onInit == 'function') {
			settings.onInit.call(dialogImpl, dialogImpl);//both this and first argument
		}
		// override onOpen if available in dialogImpl
		if (dialogImpl.settings.onOpen != undefined) {
			var onOpenFn = $.evaluate(dialogImpl.settings.onOpen, dialogImpl);
			if (typeof onOpenFn == 'function') {
				settings.onOpen = onOpenFn.bind(dialogImpl);
			}
		}
	}

	// further code for intermediate result meaning: it is really make sense if and only if 'doNotCloseOnOk' is true.
	settings.intermediateResult = settings.intermediateResult && settings.doNotCloseOnOk; // both of them must be true

	var dialogOpt = {
		formInstance: undefined, // filled later
		formData: undefined, // filled later
		wait: function() {
			$dialog.waiting();
			$(dialogId).parent().find('.ok-button').button('option', 'disabled', true);
		},
		stopWaiting: function() {
			$(dialogId).parent().find('.ok-button').button('option', 'disabled', false);
			$dialog.waiting('done');
		},
		close: function(forceResolve) {
			forceResolve = (forceResolve == undefined) ? false : forceResolve;
			$(dialogId).parent().find('.ok-button').button('option', 'disabled', false);
			if (settings.intermediateResult || forceResolve) {
				if (this.formData == undefined) {
					this.formData = this.formInstance.toObject();
				}
				deferred.resolve(this.formData, this);
			}
			$dialog.waiting('done').dialog("close");
		},
		rejectWith: function(rejectData) {
			this.rejectData = rejectData;
		},
		isOk: function() {
			return this.buttonClicked !== undefined && this.buttonClicked.hasClass('ok-button');
		},
		isCancel: function() {
			return this.buttonClicked !== undefined && this.buttonClicked.hasClass('cancel-button');
		},
		is: function(action) {
			return this.action != undefined && this.action === action;
		}
	}

	if (dialogImpl != undefined) {
		dialogOpt.dialogImpl = dialogImpl;
		dialogImpl.dialogOptions = dialogOpt;
	}

	var proceedAndResolveFn = function(event) {
		var $button = $(event.currentTarget);
		var isButtonDisabled = $button.button('option', 'disabled');
		if (!isButtonDisabled) {
			let ignoreValidation = ($button.data('validation') != undefined) ? !$button.data('validation') : settings.ignoreValidationOnOk;
			let keepDialogOpened = ($button.data('keepDialogOpened') != undefined) ? $button.data('keepDialogOpened') : settings.doNotCloseOnOk;
			let intermediateResult = ($button.data('intermediateResult') != undefined) ? $button.data('intermediateResult') : settings.intermediateResult;
			let vPromise = (ignoreValidation) ? $.when() : formInstance.validate();
			vPromise.then(() => {
				dialogOpt.buttonClicked = $button;
				let actionFn = (_0, fd, _2) => $.when(fd);
				if($button.data('action') != undefined) {
					dialogOpt.action = $button.data('action');
					if (settings.reference && typeof settings.reference[dialogOpt.action] == 'function') {
						actionFn = (evt, fd, fi) => {
							let actionResponse = settings.reference[dialogOpt.action].call(settings.reference, evt, fd, fi);
							return $.when(actionResponse).then(r => r || fd);
						};
					} else {
						console.log(`Dialog-Button action NOT available. Add "${dialogOpt.action}: function(event, formData, formInstance) {}," method to: "${settings.reference._FULL_}"`);
					}
				}
				$button.button('option', 'disabled', true).waiting();
				var toObjectPromise = (settings.returnFreshObject) ? formInstance.toObjectDeferred({}) : formInstance.toObjectDeferred();
				toObjectPromise
					.then(formData => actionFn(event, formData, formInstance))
					.then(formData => {
						const preClosePromise = (typeof settings.onPreClose === 'function') ? $.when(settings.onPreClose(formData, formInstance)) : $.when();

						preClosePromise
							.always(() => {
								if (settings.reference && typeof settings.reference['adaptData'] == 'function') {
									formData = settings.reference['adaptData'].call(settings.reference, formData);
								}
								if (intermediateResult) {
									dialogOpt.formData = formData;
									deferred.notify(formData, dialogOpt);
								} else {
									deferred.resolve(formData, dialogOpt);
								}

								if (!keepDialogOpened) {
									$button.button('option', 'disabled', false).waiting('done');
									$dialog.dialog('close');
								} else {
									if (!settings.doNotRestoreOkButton) {
										$button.button('option', 'disabled', false).waiting('done');
									}
								}
							});
					})
					.fail(() => {
						$button.button('option', 'disabled', false).waiting('done');
						let fp = (settings.rejectMessage == undefined) ? $.when() : hrd.dashboard.errorDialog(settings.rejectMessage, xlate('common.dialog.warning.title.msg'), { okLabel: xlate('common.dialog.close.btn') });
						fp.then(() => {
							$dialog.dialog('close');
							deferred.reject();
						});
					});
			});
		} else {
			event.stopPropagation();
			event.preventDefault();
		}
	};

	/**
	 * This function must be invoked from an internal button on the form when opened in a dialog
	 * It performs validation, if valid "formData" is computed and returned back. moreover the dialog will be closed.
	 * (perhaps in the future these features can be configurable).
	 */
	var innerFormButtonsFn = function(action, formData, keepDialogOpened) {
		keepDialogOpened = !!keepDialogOpened;
		dialogOpt.action = action;
		if (settings.intermediateResult || keepDialogOpened) {
			dialogOpt.formData = formData;
			this.deferred.notify(formData, dialogOpt);
		} else {
			this.deferred.resolve(formData, dialogOpt);
		}
		if (!(settings.doNotCloseOnOk || keepDialogOpened)) {
			$dialog.dialog('close');
		}
		return formData;
	}.bind({ deferred: deferred });

	/*
	 * Make dialog double size if dashboard is double size, but only if specified otherwise
	 */
	if (dashboardInstance.isDoubleSize()) {
		if (!settings.arrangeFieldSet.ignoreForceSize) {
			settings.arrangeFieldSet.size = '2x';
			if (typeof settings.width === 'number' && !settings.keepOriginalWidth) {
				settings.width = Math.min(1000, settings.width * 1.5);
			}
		}
	}

	formOptions = $.extend({}, {
		reference: settings.reference,
		innerFormButtonsFn: innerFormButtonsFn,
		errorMessagePosition: settings.errorMessagePosition,
		ignoreValidationWhenHidden: settings.ignoreValidationWhenHidden,
		arrangeFieldSet: settings.arrangeFieldSet, //{extraWidth: 3} if needed in future...
		onSetDataForm: settings.onSetDataForm,
		usedIn: 'dialog'
	}, formOptions);


	let formInstance = $dialog.data('form-instance');

	if (formInstance == undefined) {
		formInstance = new hrd.Form(dialogId, formOptions);
		// memorizzo il form instance nel container della dialog per poterlo reperire esternamente, quando necessario
		// inoltre se la dialog è riusata, il form è cachato e mantiene i componenti
		$dialog.data('form-instance', formInstance);
	}

	if (dialogImpl != undefined && typeof dialogImpl['adaptInitialData'] === 'function') {
		inputData = dialogImpl['adaptInitialData'](inputData, formInstance);
	}

	formInstance.setInputData($.extend({}, inputData))

	// lo aggiungo anche a dialogOpt per poterlo avere dopo la resolve/notify della dialog
	dialogOpt.formInstance = formInstance;

	var buttons = [];
	if (settings.showOkButton) {
		buttons.push({
			'text': settings.okLabel,
			'class': 'ok-button',
			'click': proceedAndResolveFn
		});
	}

	if (settings.showCancelButton) {
		buttons.push({
			'text': settings.cancelLabel,
			'class': 'cancel-button',
			'click': function(event) {
				if (!settings.showEditableMarker) {
					dialogOpt.buttonClicked = $(event.currentTarget);
					$dialog.dialog('close');
				} else {
					formInstance.hasChanged(true).then(result => {
						switch (result) {
							case 'continue':
								dialogOpt.buttonClicked = $(event.currentTarget);
								$dialog.dialog('close');
								break;
							case 'stop':
								break;
						}
					});
				}
			}
		});
	}

	/* prepare extra buttons (extra buttons --> buttons near to ok/cancel */
	$.map(settings.extraButtons, function(extraButton) {
		extraButton.click = proceedAndResolveFn;
		return extraButton;
	});
	
	// adapt w & h to layout-size
	if((typeof settings.width === 'string' && !settings.width.includes('%') && settings.width != 'auto') || (typeof settings.width === 'number') ) {
		settings.width = dashboardInstance.adaptSize(settings.width);
	}

	if((typeof settings.height === 'string' && !settings.height.includes('%') && settings.height != 'auto') || (typeof settings.height === 'number') ) {
		settings.height = dashboardInstance.adaptSize(settings.height);
	}
	
//	console.log(typeof settings.width, settings.width);
//	console.log(typeof settings.height, settings.height);
	

	if (typeof settings.width === 'string' && settings.width.includes('%')) {
		settings.width = parseInt(settings.width.replaceAll('%', ''));
		settings.width = $(window).width() * (settings.width / 100);
	}

	if (typeof settings.height === 'string' && settings.height.includes('%')) {
		settings.height = parseInt(settings.height.replaceAll('%', ''));
		settings.height = $(window).height() * (settings.height / 100);
	}


	buttons = settings.extraButtons.concat(buttons);
	$dialog.dialog({
		dialogClass: settings.dialogClass || '',
		modal: settings.modal,
		position: settings.position,
		resizable: settings.resizable,
		closable: settings.closable,
		maximizable: settings.maximizable,
		minimizable: settings.minimizable,
		resizeOnDlbclick: settings.resizeOnDlbclick,
		showEditableMarker: settings.showEditableMarker,
		show: settings.show,
		hide: settings.hide,

		maximizeIcon: 'f-icon far fa-window-maximize',
		minimizeIcon: 'f-icon far fa-window-minimize',
		minimizeLocation: 'right',
		restoreIcon: 'f-icon far fa-window-restore',
		height: settings.height,
		width: settings.width,
		minHeight: settings.minHeight,
		title: settings.title,
		buttons: buttons,

		create: function(event, ui) {
			/* used for 2x dialogs */
			if (settings.arrangeFieldSet && settings.arrangeFieldSet.size) {
				switch (settings.arrangeFieldSet.size) {
					case '2x':
						$dialog.closest('.ui-dialog').addClass('dialog-2x');
						break;
				}
			}
			var focusableFields = $('input, select', formInstance.$form);
			if (focusableFields.length > 1) {
				// this is needed only if input fields are available
				formInstance.$form
					.prepend('<span class="ui-helper-hidden-accessible"><input type="text" data-ignore="true"/></span>') //needed to avoid ui.dialog to focus on first field
					.css('overflow', 'hidden')
					;
			}
			if (settings.hideHeader) {
				$dialog.parent().find('.ui-dialog-titlebar').hide();
			}
			// add marker info to dialog container
			$dialog.closest('.ui-dialog').attr('data-dialog-ref', $dialog.attr('id'));
		},

		open: function(event, ui) {
			$dialog.waiting();
			if (dialogImpl != undefined) {
				dialogImpl.settings.initialData = $.extend({}, inputData);
			}
			formInstance.enhance().then(() => {
				/* check if dialog is narrow than declaration. if so adapt internal form width accordingly. Applyed IFF settings.overflow = true*/
				if(settings.overflow === true) {
					let outerWidth = $dialog.closest('.ui-dialog').outerWidth();
					if(outerWidth < settings.width) {
						let innerWidth = $dialog.width();
						let delta = outerWidth - innerWidth;
						let formWidth = settings.width - delta;
						$dialog.find('form').width(formWidth);
					}
				}
				$dialog.waiting('done');
				formInstance.initForm();
				if (inputData !== undefined) {
					let toFormOptions = undefined;
					if (typeof settings.toFormOptions === 'function') {
						toFormOptions = settings.toFormOptions();
					}
					// prefill form with initial data
					formInstance.toForm(inputData, toFormOptions);
				}
				var formData = inputData;
				let openPromise = $.when();
				if (typeof settings.onOpen === 'function') {
					formData = formData ? formData : formInstance.toObject();
					openPromise = $.when(settings.onOpen(formInstance, dialogId, formData));
				}
				if (dialogImpl != undefined && typeof dialogImpl.openDialog == 'function') {
					formData = formData ? formData : formInstance.toObject();
					openPromise = $.when(dialogImpl.openDialog(formInstance, dialogId, formData));
				}

				// repositioning to original position
				$dialog.dialog('option', 'position', $dialog.dialog('option', 'position'));

				openPromise.then(() => {
					if (dialogImpl != undefined && typeof dialogImpl.mixinFormEnhanced == 'function') {
						dialogImpl.mixinFormEnhanced(formInstance);
					}

					formInstance.decorateForm(inputData);
					var focusableElements = $('*[data-focus="true"]', formInstance.$form);
					if (focusableElements.length >= 1) {
						$.timeout(0).then(() => focusableElements.get(0).focus());
					} else {
						$('.ok-button', $(dialogId).closest('.ui-dialog')).focus();
					}

					// Fix for custom dropdowns (elements with position absolute) inside a dialog
					const $uiDialog = $dialog.closest('.ui-dialog');
					const zIndex = $uiDialog.css('z-index') * 1;

					$uiDialog.get(0).style.setProperty('--z-index', zIndex);
				});

			});
			if (settings.closeOnOverlay) {
				// fix: the close on overlay was erroneally added to all available overlays and not only to the requested one
				let uiDialog = $dialog.closest('.ui-dialog');
				let overlay = uiDialog.next('.ui-widget-overlay');
				if (!overlay.exists()) {
					overlay = uiDialog.next('#dialog-extend-fixed-container').next('.ui-widget-overlay');
				}
				overlay.off('click.overlay').on('click.overlay', () => {
					$dialog.dialog('close');
				});
			}
		},

		beforeClose: function(event, ui) {
			if (typeof settings.onBeforeClose === 'function') {
				settings.onBeforeClose(formInstance, dialogId, dialogOpt);
			}
			/* ripristino delle condizioni iniziali */
			if (deferred.state() !== 'pending' || !settings.skipResetOnFail) {
				formInstance.resetForm();
			}
		},

		close: function(event, ui) {
			if (typeof settings.onClose === 'function') {
				settings.onClose(formInstance, dialogId);
			}
			if (dialogImpl != undefined && typeof dialogImpl.onCloseDialog == 'function') {
				dialogImpl.onCloseDialog(formInstance, dialogId, dialogOpt);
			}
			if (deferred.state() === 'pending') {
				deferred.reject(dialogOpt);
			}
			if (settings.destroyOnClose) {
				$dialog.remove();
				if (dialogImpl != undefined && typeof dialogImpl.destroyOnClose === 'function') {
					dialogImpl.destroyOnClose(formInstance, dialogId);
				}
			}
		},
	});

	/* adding custom events functions for dialog*/
	var events = $dialog.data('events');
	events = events ? events.split(' ') : [];
	var widget = $dialog.dialog('widget');
	widget.off('.sfd');
	$.each(events, function(index, evt) {
		var eventName = ($dialog.data('name') ? $dialog.data('name') : $dialog.attr('id')) + '-' + evt;
		var fnName = $.camelCase(eventName);
		if (settings.reference && typeof settings.reference[fnName] == 'function') {
			widget.on(evt + ".sfd", function(e) {
				var deferred = $.Deferred();
				var promise = settings.reference[fnName].call(settings.reference, e, formInstance);
				$.when(promise).then(function() {
					deferred.resolve();
				})
			});
		} else {
			console.log('function "' + fnName + '" not available in proper object reference', settings.reference);
		}
	});

	return deferred.promise();
};
